import React, { useState, useCallback } from "react";
import { TextField, List, ListItem, ListItemText, CircularProgress, Box } from "@mui/material";
import axios from "axios";
import debounce from "lodash.debounce";

const ContactSearch = ({ onSelectContact }) => {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("jwtToken");

    const fetchContacts = useCallback(async (searchTerm) => {
        if (!searchTerm || searchTerm.length < 3) {
            setResults([]);
            return;
        }

        setLoading(true);
        try {
            const response = await axios.get(`${baseURL}/usuario/busca`, {
                params: { q: searchTerm },
                headers: { Authorization: `Bearer ${token}` },
            });
            setResults(response.data);
        } catch (error) {
            console.error("Erro ao buscar usuários:", error);
        } finally {
            setLoading(false);
        }
    }, [baseURL, token]);


    const debouncedSearch = useCallback(() => {
        debounce(fetchContacts, 500)();
    }, [fetchContacts]);


    const handleChange = (e) => {
        const value = e.target.value;
        setQuery(value);
        debouncedSearch(value);
    };

    return (
        <Box>
            <TextField
                label="Buscar usuário"
                variant="outlined"
                fullWidth
                value={query}
                onChange={handleChange}
            />
            {loading && <CircularProgress size={24} sx={{ mt: 2 }} />}
            <List>
                {results.map((user) => (
                    <ListItem button key={user.id} onClick={() => onSelectContact(user)}>
                        <ListItemText primary={user.nome} secondary={user.numero} />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default ContactSearch;
